<template>
  <div class="ui-content">
    <div class="ui-box">
      <el-form ref="form" class="ui-box-from-heartDetail" label-position="right" :model="form" label-width="150px">
        <baseInfo :data.sync="form"></baseInfo>
        <heartInfo :data.sync="form" :type='1'></heartInfo>
        <heartInfo v-if="form.tbIsHasFhr2" :data.sync="form" :type='2'></heartInfo>
        <div class="ui-box-monitorDetail-button">
          <el-button class="return" @click="returnList">返回列表</el-button>
          <el-button class="return" type="primary" v-has="pathCode+':sendMessage'" @click="sendMessage">发消息</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
const files = require.context('/', false, /\.vue$/);
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2);
const fileName = 'heartDetail';
const controller = 'cardiacStatistics';
import { mapGetters, mapActions } from 'vuex'
import baseInfo from '@/components/heartDetail/baseInfo'
import heartInfo from '@/components/heartDetail/heartInfo'
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this;
    return {
      show: true,
      pathCode: `${suffixList.join('')}${fileName}`,
      loading: false,
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      form: {

      }
    };
  },
  computed: {
    isFormNull () {
      return !this.form || Object.keys(this.form).length === 0
    },
    isDataNull () {
      return this.isFormNull || !this.form.tbData
    },
    data () {
      if (this.isDataNull) {
        return []
      } else {
        return this.form.tbData.split(',')
      }
    },
    dataLength () {
      return this.data.length
    },
    max () {
      return Math.floor(this.data.length / 4)
    },
    isSee () {
      if (Object.keys(this.lastBreadCrumb.length > 0)) {
        if (['胎心详情'].includes(this.lastBreadCrumb[this.fileName])) {
          return true;
        }
      }
      return false;
    },
    pageType () {
      if (Object.keys(this.lastBreadCrumb.length > 0)) {
        if (['胎心详情'].includes(this.lastBreadCrumb[this.fileName])) {
          return 'see';
        }
      }
      return 'add';
    },
    ...mapGetters(['chatShow', 'lastBreadCrumb', 'refreshPage'])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.init();
        this.$store.dispatch('setRefreshPage', false);
      }
    }
  },
  methods: {
    ...mapActions([
      "onGetContactUserList"
    ]),
    sendMessage () {
      const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'));
      const item = {
        conversationId: this.form.tbUuid,
        conversationType: "singleChat",
        isPinned: false,
        lastMessage: { id: '', type: 'txt', chatType: 'singleChat', msg: '', ext: {}, to: this.form.tbUuid, from: userInfo?.userId, time: new Date().getTime() },
        pinnedTime: 0,
        unReadCount: 0
      }
      this.$store.dispatch('onGetContactUserList', item);
      if (!this.chatShow) {
        this.$store.commit('SET_CHAT_SHOW', true)
      }
    },
    calculateAge (birthDate) {
      if (!birthDate) {
        return ''
      }
      birthDate = new Date(birthDate)
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      // 如果当前月份小于出生月份，或者月份相同但日期小于出生日期，则年龄减1
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    clear () {
      this.form = {

      };
    },
    init () {
      if (this.pageType !== 'add') {
        this.getById(this.$route.query.tbId);
      } else {
        this.clear();
      }
    },
    initForm (form) {
      let data = form.tbData.split(',').map(Number)
      const seconds = Math.floor(data.length / 4)
      if (!form.tbStartTime) {
        form.tbStartTime = form.createTime
      }
      if (!form.tbEndTime) {
        form.tbEndTime = new Date(new Date(form.tbStartTime).getTime() + 1000 * seconds).format('yyyy-MM-dd hh:mm:ss')
      }
      form.age = this.calculateAge(form.birthday)
      return form;
    },
    getById (id) {
      this.$http.get(`/${controller}/findByCardiacId`, { tbId: id }).then((res) => {
        if (res.code === 1000) {
          this.form = this.initForm(res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    returnList () {
      this.closeTab(
        this.filePath,
        '',
        this.fileName,
        ['', ...suffixList].join('/'),
        false
      );
    },
  },
  created () {
    this.init();
  },
  destroyed () { },
  components: {
    baseInfo,
    heartInfo
  }
};
</script>


<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    overflow-x: auto;
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-heartDetail {
      padding-top: 4px;

      .ui-box-monitorDetail-button {
        margin-top: 50px;
        margin-left: 217px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        .return {
          padding: 6px 25px;
          margin-right: 40px;
          border-radius: 3px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          line-height: 22px;
          &:focus {
            outline: none;
          }
        }
      }
      .addButton {
        cursor: pointer;
        margin-top: 5px;
        margin-bottom: 24px;
        margin-left: 170px;
        width: 645px;
        height: 32px;
        border-radius: 2px;
        border: 1px dashed rgba(0, 0, 0, 0.25);
        font-size: 14px;
        background-color: rgba(245, 245, 245, 1);
        color: #999999;
        display: block;
        &:focus {
          outline: none;
        }
        .margin11 {
          margin-right: 11px;
        }
      }
      ::v-deep .el-form-item {
        margin-bottom: 24px;
        .ui-box-tableList-img {
          width: 80px;
          height: 80px;
          background: #d8d8d8;
          display: inline-block;
          vertical-align: top;
        }
        &.inline {
          display: inline-block;
          vertical-align: top;
        }
        &.height-auto {
          ::v-deep .el-form-item__content {
            height: auto;
          }
        }

        ::v-deep .el-form-item__label {
          height: 32px;
          line-height: 32px;
          padding: 0;
          margin: 0;
        }
        ::v-deep .el-form-item__error {
          padding-left: 20px;
        }
        ::v-deep .el-form-item__content {
          height: 100%;
          padding-left: 20px;
          line-height: 32px;
        }
        .ui-box-from-heartDetail-text {
          cursor: pointer;
          line-height: 32px;
          display: inline-block;
          vertical-align: top;
          height: 100%;
          width: 48px;
        }
        .width645 {
          width: 645px;
        }
        .margin40 {
          margin-right: 40px;
        }
        .width761 {
          width: 761px;
        }

        .ui-box-from-heartDetail-input {
          width: 275px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          &.width645 {
            width: 645px;
          }
          ::v-deep .el-icon-time,
          ::v-deep .el-icon-arrow-down,
          ::v-deep .el-icon-arrow-up,
          ::v-deep .el-icon-date,
          ::v-deep .el-icon-date,
          ::v-deep .el-range__icon,
          ::v-deep .el-range-separator,
          ::v-deep .el-range-input,
          ::v-deep .el-range__close-icon,
          ::v-deep .el-icon-circle-close,
          ::v-deep .el-icon-arrow-up,
          ::v-deep .el-icon-date,
          ::v-deep .el-input__inner {
            vertical-align: top;
            height: 30px;
            line-height: 30px;
            border: none;
          }
          ::v-deep .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          ::v-deep .el-input__inner::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          ::v-deep .el-input__inner[type="number"] {
            -moz-appearance: textfield;
          }
          ::v-deep .el-input-group__append {
            height: 30px;
            border: none;
            &::-moz-placeholder,
            &::-webkit-input-placeholder,
            &::-ms-input-placeholder {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #cccccc;
            }
          }
          ::v-deep .el-input-group__append {
            padding: 0 15px;
          }
        }
        .ui-box-from-heartDetail-button {
          margin-left: 20px;
          vertical-align: top;
          padding: 8px 32px;
          border-radius: 3px;
          &:focus {
            outline: none;
          }
        }
        .ui-box-from-heartDetail-img {
          cursor: pointer;
          line-height: 32px;
          margin-right: 8px;
        }
        .ui-box-from-heartDetail-text {
          cursor: pointer;
          line-height: 32px;
          display: inline-block;
          vertical-align: middle;
          height: 100%;
          margin-right: 30px;
        }
      }
    }
    .ui-box-heartDetail-button {
      margin-left: 217px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
      .submit {
        margin-left: 0;
        padding: 6px 25px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}

.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-heartDetail {
      padding-top: 4px;
      .ui-top {
        width: 100%;
        margin: 10px 0;
        height: 161px;
        background: #ffffff;
        padding: 20px 24px;
        box-sizing: border-box;
        .ui-title {
          font-weight: 400;
          font-size: 16px;
          color: #000000;
          line-height: 24px;
        }
        .ui-label {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 22px;
        }
        .ui-button {
          width: 60px;
          height: 27px;
          background: #3d7fff;
          border-radius: 2px;
          font-weight: 400;
          font-size: 11px;
          color: #ffffff;
          line-height: 27px;
          text-align: center;
        }
      }
      ::v-deep .el-form-item {
        margin-bottom: 24px;
        .el-form-item__label {
          height: 32px;
          line-height: 32px;
          padding: 0;
          margin: 0;
        }
        .el-form-item__content {
          height: 100%;
          padding-left: 20px;
          line-height: 32px;
        }
        .ui-box-from-heartDetail-text {
          cursor: pointer;
          line-height: 32px;
          display: inline-block;
          vertical-align: top;
          height: 100%;
          width: 48px;
        }
        .width645 {
          width: 645px;
        }
        .margin40 {
          margin-right: 40px;
        }
        .el-form-item__error {
          padding-left: 20px;
        }
        .ui-box-from-heartDetail-input {
          width: 275px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          &.width645 {
            width: 645px;
          }
          .el-icon-time,
          .el-icon-arrow-down,
          .el-icon-arrow-up,
          .el-icon-date,
          .el-icon-date,
          .el-range__icon,
          .el-range-separator,
          .el-range-input,
          .el-icon-circle-close,
          .el-icon-arrow-up,
          .el-icon-date,
          .el-input__inner {
            vertical-align: top;
            height: 30px;
            line-height: 30px;
            border: none;
          }
          .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          .el-input__inner::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          .el-input__inner[type="number"] {
            -moz-appearance: textfield;
          }
          .el-input-group__append {
            height: 30px;
            border: none;
            &::-moz-placeholder,
            &::-webkit-input-placeholder,
            &::-ms-input-placeholder {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #cccccc;
            }
          }
          .el-input-group__append {
            padding: 0 15px;
          }
        }
        .ui-box-from-heartDetail-button {
          margin-left: 20px;
          vertical-align: top;
          padding: 8px 32px;
          border-radius: 3px;
          &:focus {
            outline: none;
          }
        }
      }
    }
    .ui-box-heartDetail-button {
      margin-left: 217px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
      .submit {
        margin-left: 0;
        padding: 6px 25px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
